import { Injectable } from '@angular/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { environment } from 'environments/environment';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { DrakeSharedService } from './drake-shared.service';
import { Notification as NotificationCustom } from 'app/layout/common/notifications/notifications.types';


@Injectable({ providedIn: 'root' })
export class FirebaseMessagingService {
  private messaging;

  constructor(private notificationsService: NotificationsService, private drakeSharedService: DrakeSharedService) {
    const app = initializeApp(environment.firebase);
    this.messaging = getMessaging(app);
    this.requestPermission();
    this.listen();
    
  }

  async requestPermission(): Promise<void> {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted' || permission === 'default' || permission === 'denied') {
        const token = await getToken(this.messaging, { vapidKey: environment.firebase.vapidKey });
        console.log('FCM Token:', token);
        // Qui puoi salvare il token sul tuo backend se necessario
      } else {
        console.error('Permesso per le notifiche negato.');
      }
    } catch (error) {
      console.error('Impossibile ottenere il permesso per le notifiche.', error);
    }
  }

  listen(): void {

    onMessage(this.messaging, (payload: any) => {
      console.log('Messaggio ricevuto da Firebase:', payload);
      const notification: NotificationCustom = {
        _id: Date.now().toString(),
        Title: payload?.notification?.title || 'Notifica',
        Content: payload?.notification?.body || '',
        Read: false,
        Deleted: false,
      };

      this.notificationsService.update(notification._id, notification)
      this.notificationsService.addNotification(notification);
      this.drakeSharedService.showTemporaryNotification(notification.Content, "info")
    });
  }
}